import { render, staticRenderFns } from "./ShowOneStage.vue?vue&type=template&id=0a7dbafe&scoped=true"
import script from "./ShowOneStage.vue?vue&type=script&lang=js"
export * from "./ShowOneStage.vue?vue&type=script&lang=js"
import style0 from "./ShowOneStage.vue?vue&type=style&index=0&id=0a7dbafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7dbafe",
  null
  
)

export default component.exports